var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("settings.users.userList")))]),
      _c(
        "v-row",
        { staticStyle: { "margin-bottom": "15px" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("global.search"),
                  "append-icon": "search",
                  "hide-details": "",
                  "single-line": ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "div",
            [
              _vm.$store.getters["isWnbUser"] &&
              _vm.$store.getters["companyContext"] != null &&
              (_vm.$store.getters["userProperties"].system_settings
                .is_module_travel_service_enabled === 2 ||
                _vm.$store.getters["userProperties"].system_settings
                  .is_module_delegation_enabled === 2)
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: _vm.$store.getters["Ajax/loading"],
                        block: "",
                        color: "primary"
                      },
                      on: { click: _vm.syncWithWnb }
                    },
                    [_vm._v(_vm._s(_vm.$t("settings.users.syncUsersWithWNB")))]
                  )
                : _vm._e()
            ],
            1
          ),
          !_vm.$store.getters["isWnbUser"]
            ? _c(
                "div",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        block: "",
                        color: "accent",
                        to: _vm.baseAddress + "new"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("settings.users.addNewUser")))]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.users,
          search: _vm.search,
          loading: _vm.$store.getters["Ajax/loading"] ? "accent" : false
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.name))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.surname))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.login))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.email))
                  ]),
                  _c(
                    "td",
                    { staticClass: "text-center" },
                    [
                      !_vm.$store.getters["isWnbUser"]
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: {
                                                disabled:
                                                  _vm.$store.getters[
                                                    "Ajax/loading"
                                                  ],
                                                icon: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.passwordReset(
                                                    props.item.id
                                                  )
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [
                                            _c("v-icon", [
                                              _vm._v("fa-user-shield")
                                            ])
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "settings.users.passwordReset.tooltip"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: {
                                            to: _vm.editAddress(props.item.id),
                                            icon: ""
                                          }
                                        },
                                        on
                                      ),
                                      [_c("v-icon", [_vm._v("edit")])],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.edit")) + " ")]
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }